import { KlartextEventConfig } from '@common/types/klartextEventConfig';
import { FrontendSpecificConfig } from '@configTypes/eventConfigs';
import { CSSProperties, type ReactNode } from 'react';

interface SpeechThemeProps {
  children: ReactNode;
  klartextEventConfig: KlartextEventConfig<FrontendSpecificConfig> | null;
}

export function SpeechTheme({ children, klartextEventConfig: KlartextEventConfig }: SpeechThemeProps) {
  const themeCssVars = KlartextEventConfig
    ? {
        '--party-color-text': KlartextEventConfig?.frontendSpecificConfig.eventColorText,
        '--party-color-background': KlartextEventConfig?.frontendSpecificConfig.eventColorBackground,
      }
    : undefined;
  return (
    <>
      <div style={themeCssVars as CSSProperties}>{children}</div>
    </>
  );
}
